import { formEncode, handleResponse, nextJsonApi } from '@/API/core';

const tabs = {
  fetchTabs: async (companyId: string, employeeId: string) => {
    let response = null;
    try {
      response = await nextJsonApi.post(
        '/tabs',
        formEncode({ companyId, employeeId })
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default tabs;
